<script>
  import { vendey, csvRows, pipe } from '../lib/api.js';
  import DataTable from './DataTable.svelte';
  import { exportCsv } from '../lib/export.js';
  export let session;
  let totals = []; let closing = []; let error = ''; let busy = false;
  async function load() {
    busy = true; error = '';
    try {
      const result = await Promise.all([vendey('sp_sumatoria_tipo_pago', pipe([session.seller, session.store])), vendey('spVNT_CIERRECAJACSV', pipe([session.boxSelectionId, session.boxId, '']))]);
      totals = csvRows(result[0]); closing = csvRows(result[1]);
    } catch (reason) { error = reason.message; } finally { busy = false; }
  }
</script>
<section class="page-panel"><span class="eyebrow">{session.boxName}</span><h2>Cierre de caja</h2><p>{session.seller} · {session.store}</p><button class="primary-action" on:click={load} disabled={busy}>{busy ? 'Consultando…' : 'Consultar cierre de turno'}</button>
  {#if error}<p class="notice error" role="alert">{error}</p>{/if}<h3>Totales por tipo de pago</h3><DataTable rows={totals} caption="Pagos de la caja" /><h3>Cierre de caja</h3><DataTable rows={closing} caption="Resumen del turno" />
  <button class="secondary-action" disabled={!closing.length} on:click={() => exportCsv(closing, 'cierre-caja.csv')}>Exportar cierre CSV</button>
</section>
